'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DirectoryListingForm } from './DirectoryListingForm';
interface DirectoryListingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Dialog that lets a signed-in user request to be added to the partner
 * directory. Wraps the shared {@link DirectoryListingForm}.
 */
export function DirectoryListingDialog(t0) {
  const $ = _c(4);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg"><DialogHeader><DialogTitle>Get listed on the directory</DialogTitle><DialogDescription>Tell us about your business and our team will be in touch about adding you to the directory.</DialogDescription></DialogHeader><DirectoryListingForm /></DialogContent>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onOpenChange || $[2] !== open) {
    t2 = <Dialog open={open} onOpenChange={onOpenChange}>{t1}</Dialog>;
    $[1] = onOpenChange;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}